
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { addDays, format } from 'date-fns'
import { useAuth } from '../../contexts/AuthContext'
import { usePost } from './../../apis/ApiRequests'
import { dateToString } from '../../utils/Library'
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper } from '@mui/material'
import { facilityData } from '../../Store'

const UnloadMonitor = () => {

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const { authInfo }   = useAuth()
    const facilityCode   = authInfo.facilityCode ? authInfo.facilityCode : facilityData.facilityCode
    const facilityName   = authInfo.facilityName
    const userId         = authInfo.userId ? authInfo.userId : 'Signage'
    const luserName      = authInfo.userName
    const authority      = authInfo.authority
    const today          = format(addDays(new Date(), 0), 'yyyy-MM-dd')
    const navigate       = useNavigate()

	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [ entryDate,  setEntryDate  ] = useState(today)
    const [ unloadList, setUnloadList ] = useState([])
    
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
    // API - searchDataByUnload / Signage
	//-----------------------------------------------
    const { response : searchData_res, post:searchData_post } = usePost()
    const searchData = async () => {
        const numericDate = dateToString(entryDate)
        const postData = {
            'className'    : 'mch.models.table.Signage',
            'methodName'   : 'searchDataByUnload',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'entryDate'    : numericDate,
        }
        await searchData_post(postData)
    }
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        searchData()
        
        // 30秒ごとにデータを更新するタイマーを設定
        const interval = setInterval(searchData, 15000)
    
        // コンポーネントのアンマウント時にタイマーをクリア
        return () => clearInterval(interval)
        
    },[])
	//-----------------------------------------------
    // useEffect - searchDataByUnload / Signage
	//-----------------------------------------------
    useEffect(() => {
        setUnloadList([])
        if (searchData_res) {
            setUnloadList(searchData_res.Data)
        }
    }, [searchData_res])

	//===============================================
	// eventHandler
	//===============================================
    const handleClick_header = () => {
        userId == 'Signage' ? navigate('/') : navigate('/signageMenu')
    }
    //===============================================
    // Css
    //===============================================
    const unloadMonitor_table_cell_header = {
        backgroundColor: '#fff', color: '#005243', width: '130px', borderRight:'3px solid #005243', padding:'5px',  fontSize:'2em', fontWeight:'bold', height:'2em'
    }
    const unloadMonitor_table_cell = {
        backgroundColor: '#005243', color: '#fff', padding:'5px', fontSize:'2em', fontWeight:'bold', borderBottom:'3px solid #fff', borderRight:'3px solid #fff'
    }
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <div className='bidGroup signageContens' style={{ height: '100vh',overflow:'hidden' }}>
                <div onClick={() => handleClick_header()}>
                    <span style={{fontSize:'2em', fontWeight:'bold', color:'#fff'}}>【</span>
                    <span style={{fontSize:'2em', fontWeight:'bold', color:'#fff'}}>水揚げ速報</span>
                    <span style={{fontSize:'2em', fontWeight:'bold', color:'#fff', marginLeft:'1em'}}>{ today }】</span>
                </div>
                <div>
                    <TableContainer component={Paper} style={{border:'none', backgroundColor:'#efefef', marginTop:'1em'}}>
                        <Table stickyHeader sx={{ minWidth: '500px', padding:0 }} size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={ unloadMonitor_table_cell_header } style={{ width: '10vh',borderLeft:'3px solid #fff' }} align='center'>No</TableCell>
                                    <TableCell sx={ unloadMonitor_table_cell_header } style={{ width: '30vh' }} align="left">荷主</TableCell>
                                    <TableCell sx={ unloadMonitor_table_cell_header } style={{ width: '40vh' }} align="left">品名</TableCell>
                                    <TableCell sx={ unloadMonitor_table_cell_header } style={{ width: '11vh' }} align="center">単位</TableCell>
                                    <TableCell sx={ unloadMonitor_table_cell_header } style={{ width: '15vh' }} align="center">数量</TableCell>
                                    <TableCell sx={ unloadMonitor_table_cell_header } style={{ width: '15vh' }} align="center">容器</TableCell>
                                    <TableCell sx={ unloadMonitor_table_cell_header } style={{ width: '15vh' }} align="center">Kg数</TableCell>
                                    <TableCell sx={ unloadMonitor_table_cell_header } style={{ width: '40vh' }} align="center">備考</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {unloadList.map((row, index) => (
                                <TableRow key={row.id} sx={{ backgroundColor: index % 2 === 0 ? '#fff' : '#E6E9EE'} } >
                                    <TableCell sx={ unloadMonitor_table_cell } align="right" style={{borderLeft:'3px solid #fff'}}>{ row.id }</TableCell>
                                    <TableCell sx={ unloadMonitor_table_cell } align="left">{ row.senmei }</TableCell>
                                    <TableCell sx={ unloadMonitor_table_cell } align="left">{ row.displayGyoshu }</TableCell>
                                    <TableCell sx={ unloadMonitor_table_cell } align="center">{ row.kgKubunName }</TableCell>
                                    <TableCell sx={ unloadMonitor_table_cell } align="right">{ row.suryo }</TableCell>
                                    <TableCell sx={ unloadMonitor_table_cell } align="center">{ row.yoki }</TableCell>
                                    <TableCell sx={ unloadMonitor_table_cell } align="right">{ row.kgSuryo }</TableCell>
                                    <TableCell sx={ unloadMonitor_table_cell } align="right">{  }</TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        </>
    )
}
export default UnloadMonitor
  